import React, { useState } from "react";
import "./FAQs.scss";

const FAQS = [
  /* --- COLUMN 1 --- */
  {
    q: "How does the BrandKeeper™ monthly subscription work?",
    a: "You receive a dedicated monthly allowance of Creative Credits (6 on Basic, 12 on Pro, 20 on Elite) to submit design and marketing asset requests. We work through your active queue based on your plan’s production priority, delivering initial drafts in 2–4 business days.",
  },
  /* --- COLUMN 2 --- */
  {
    q: "What does the $1,800 setup fee cover, and when does it apply?",
    a: "The $1,800 setup fee covers a comprehensive brand audit, master file organization, and aligning our production team with your brand guidelines. Exemption for returning clients: If you pause and reactivate within 12 months, your setup fee is completely waived—provided your core brand identity has not undergone a major strategic shift requiring team re-orientation.",
  },
  /* --- COLUMN 1 --- */
  {
    q: "Can I start if we don't have established brand guidelines?",
    a: "No. BrandKeeper™ is built for existing brands with a core logo, visual identity, and basic assets. If you are starting from scratch or doing a total pivot, our standalone Brand Identity Building service will establish your core foundation first.",
  },
  /* --- COLUMN 2 --- */
  {
    q: "How do Creative Credits and turnaround times work in practice?",
    a: "Each asset request requires a specific credit value based on complexity. Once submitted, initial drafts are delivered within 2–4 business days. Your plan’s production scheduling tier (Standard, Priority, or Highest Priority) determines how quickly queued requests and subsequent revisions move into active production.",
  },
  /* --- COLUMN 1 --- */
  {
    q: "Do we own the final design files and IP?",
    a: "Yes. You receive full commercial rights to all finalized, delivered design assets created during your active subscription. We manage, organize, and archive your master asset library so your team always has seamless access.",
  },
  /* --- COLUMN 2 --- */
  {
    q: "Is there a long-term commitment?",
    a: "No, standard plans operate on a flexible month-to-month basis. However, if you are looking for a dedicated long-term partnership (such as 6 months or 1 year), we can negotiate custom commitments and structure a tailored agreement to match your goals.",
  },
  /* --- COLUMN 1 (BOTTOM) --- */
  {
    q: "What happens to unused credits at the end of the month?",
    a: "Basic plans do not include credit rollover, so unused credits expire at the end of each billing cycle. Pro plans allow you to roll over up to 3 unused credits into the next month, while Elite plans allow up to 6 unused credits to roll over. Unused rollover credits remain active for as long as your subscription is maintained.",
  },
  /* --- COLUMN 2 (BOTTOM) --- */
  {
    q: "What happens to our brand files if we pause or cancel?",
    a: "When a subscription ends, we retain your core brand essentials (logos, color palettes, guidelines, and core brand assets) in our secure environment for 12 months so you can reactivate without paying a new setup fee. However, raw working files and active production drafts are purged at cancellation.",
  },
];

export default function FAQs() {
  // Set index 0 open by default for mobile accordion
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="faqs" aria-labelledby="faqs-title">
      <div className="faqs__inner">
        <h2 id="faqs-title" className="faqs__title">FAQs</h2>

        <div className="faqs__grid">
          {FAQS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div 
                className={`faqs__item ${isOpen ? "is-open" : ""}`} 
                key={i}
              >
                <button 
                  className="faqs__q-btn" 
                  onClick={() => toggleAccordion(i)}
                  aria-expanded={isOpen}
                  type="button"
                >
                  <h3 className="faqs__q">{item.q}</h3>
                  <span className="faqs__icon" aria-hidden="true" />
                </button>
                <p className="faqs__a">{item.a}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}